import {
  Action,
  combineReducers,
  configureStore,
  PreloadedState,
  ThunkAction
} from '@reduxjs/toolkit';
import { apiSlice } from './apiSlice';
import { authSlice } from './slices/authSlice';
import { searchSlice } from './slices/searchSlice';

const rootReducer = combineReducers({
  [apiSlice.reducerPath]: apiSlice.reducer,
  auth: authSlice.reducer,
  search: searchSlice.reducer
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: {
          ignoredActions: [
            // Ignore RTK Query actions that might contain non-serializable data
            'api/executeQuery/pending',
            'api/executeQuery/fulfilled',
            'api/executeQuery/rejected',
            'api/executeMutation/pending',
            'api/executeMutation/fulfilled',
            'api/executeMutation/rejected'
          ],
          ignoredPaths: [
            // Ignore paths where Blobs might be stored
            'api.mutations',
            'api.subscriptions'
          ],
          ignoredActionPaths: [
            'payload',
            'meta.arg',
            'meta.baseQueryMeta'
          ]
        }
      }).concat(apiSlice.middleware)
  });
};

export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
export type RootState = ReturnType<typeof rootReducer>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
